/* Polsk katalog for locale-investment-quick-purchase.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'investments.quickPurchaseTitle': 'Sprawdź i zatwierdź zakup',
  'investments.quickPurchaseIntro': 'Plumme odczytało dokument i przygotowało zakup. Sprawdź kwoty i zatwierdź.',
  'investments.quickExistingInstrument': 'Zakup zostanie zarejestrowany w istniejącej inwestycji: {name}.',
  'investments.quickClassification': 'Konto księgowe',
  'investments.quickCurrentAsset': '1810 · Rynkowe aktywa obrotowe',
  'investments.quickCurrentAssetName': 'Notowane akcje i jednostki funduszy inwestycyjnych',
  'investments.quickLongTerm': '1350 · Inwestycja długoterminowa',
  'investments.quickBankRequired': 'Firma musi mieć aktywny rachunek bankowy w NOK, zanim zakup będzie można zaksięgować.',
  'investments.quickTaxLater': 'Ustalane automatycznie na podstawie dokumentacji rocznej i podatkowej',
  'investments.editCurrency': 'Zmień walutę',
  'investments.editFact': 'Edytuj {field}',
  'investments.quickActualNokAmount': 'Faktycznie obciążono w NOK',
  'investments.quickActualNokHelp': 'Wpisz kwotę w NOK, którą faktycznie obciążono za zakup w {currency}.',
  'investments.quickResult': 'Po zatwierdzeniu Plumme utworzy inwestycję, zaksięguje zakup i zaktualizuje stan posiadania. Jednoznaczna transakcja bankowa zostanie powiązana automatycznie teraz lub przy następnym otwarciu Inwestycji.',
  'investments.quickApprove': 'Zatwierdź, zaksięguj i zaktualizuj stan',
  'investments.quickApproving': 'Księgowanie zakupu …',
  'investments.quickSaleTitle': 'Sprawdź i zatwierdź sprzedaż',
  'investments.quickSaleIntro': 'Plumme odczytało dokument sprzedaży i obliczyło skutek księgowy oraz podatkowy na podstawie zarejestrowanej historii.',
  'investments.saleCalculating': 'Obliczanie FIFO i podstawy kosztu …',
  'investments.saleCannotQuickApprove': 'Tego brakuje, zanim sprzedaż będzie można szybko zatwierdzić',
  'investments.saleInstrumentMissing': 'Inwestycji nie ma w rejestrze. Najpierw zarejestruj stan początkowy lub wcześniejsze zakupy.',
  'investments.saleInstrumentAmbiguous': 'Do dokumentu pasuje kilka inwestycji. Wybierz właściwą inwestycję ręcznie.',
  'investments.saleTaxTreatmentMissing': 'Traktowanie podatkowe inwestycji nie zostało ustalone.',
  'investments.instrumentTypeUnsupported': 'Typ instrumentu został rozpoznany, ale księgowanie dla tego typu nie jest jeszcze obsługiwane.',
  'investments.netSettlement': 'Rozliczenie netto',
  'investments.releasedBookCost': 'Rozliczony koszt księgowy',
  'investments.releasedBookValue': 'Rozliczona wartość księgowa',
  'investments.releasedTaxCost': 'Rozliczony koszt podatkowy',
  'investments.bookProfitLoss': 'Księgowy zysk/strata',
  'investments.taxProfitLoss': 'Podatkowy zysk/strata',
  'investments.fifoCalculation': 'Obliczone FIFO',
  'investments.quickSaleResult': 'Zatwierdzenie zaksięguje sprzedaż, zaktualizuje stan posiadania i automatycznie powiąże jednoznaczne rozliczenie bankowe.',
  'investments.quickApproveSale': 'Zatwierdź, zaksięguj i zaktualizuj stan',
  'investments.completeSale': 'Uzupełnij sprzedaż',
});
